var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1d991a5fc5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 57.5625 37.5 L 223 37.5 L 223 295 L 57.5625 295 Z M 57.5625 37.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f11fcec97f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 152 72 L 317.8125 72 L 317.8125 337.5 L 152 337.5 Z M 152 72 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d991a5fc5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 174.3125 274.300781 C 174.3125 221.578125 174.3125 168.859375 174.3125 116.128906 L 139.160156 136.398438 L 139.160156 169.949219 L 92.75 169.949219 L 92.75 132.769531 C 136.109375 107.761719 179.46875 82.769531 222.839844 57.761719 L 187.6875 37.5 C 144.328125 62.507812 100.957031 87.496094 57.601562 112.507812 C 57.601562 162.503906 57.601562 212.507812 57.601562 262.507812 L 92.75 282.769531 L 92.75 205.050781 L 139.160156 205.050781 L 139.160156 294.5625 Z M 174.3125 274.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f11fcec97f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 317.78125 153.023438 L 317.78125 112.507812 L 249.191406 72.960938 C 233.160156 82.210938 217.113281 91.457031 201.082031 100.710938 C 201.082031 153.433594 201.082031 206.152344 201.082031 258.871094 L 236.21875 238.609375 L 236.21875 205.050781 L 282.640625 205.050781 L 282.640625 242.230469 C 239.285156 267.238281 195.914062 292.242188 152.554688 317.238281 L 187.6875 337.5 L 317.773438 262.507812 C 317.773438 231.652344 317.773438 200.800781 317.773438 169.949219 L 236.21875 169.949219 L 236.21875 106.003906 Z M 317.78125 153.023438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aad4f9d6045f0d3a55c9ec27798c1ac9.svg";
export { ForwardRef as ReactComponent };